import { useState } from "react";
import { Navigate, useNavigate, Link, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { Logo } from "@/components/site/Primitives";
import { useSeo } from "@/lib/seo";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const target = location.state?.from || "/admin";
  useSeo({ title: "Yönetici Girişi | Yeni Mercan", path: "/admin/login", noindex: true });
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (user) return <Navigate to={target} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      toast.success("Hoş geldiniz!");
      navigate(target, { replace: true });
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ym-dark min-h-screen grid lg:grid-cols-2" data-testid="admin-login-page">
      <div className="relative hidden lg:block">
        <img src="/images/ambiance.jpg" alt="" className="absolute inset-0 h-full w-full object-cover opacity-50" />
        <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#140D0B]" />
        <div className="absolute bottom-12 left-12 max-w-sm">
          <p className="eyebrow">Yönetim Paneli</p>
          <p className="font-serif-ym text-4xl mt-3">Menünüz, rezervasyonlarınız ve siteniz tek yerde.</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="admin-login-form">
          <Logo size={88} />
          <h1 className="mt-8 font-display text-2xl tracking-[0.12em]">Yönetici Girişi</h1>
          <p className="mt-2 text-sm text-[#CBBBAE]">Yeni Mercan Restoran yönetim paneli</p>
          <div className="mt-8 space-y-4">
            <input className="ym-input" placeholder="E-posta" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="username" data-testid="admin-login-email-input" />
            <input className="ym-input" type="password" placeholder="Şifre" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" data-testid="admin-login-password-input" />
          </div>
          {error && <p className="mt-4 text-sm text-[#E8765E]" data-testid="admin-login-error">{error}</p>}
          <button disabled={loading} className="btn-gold w-full mt-6" data-testid="admin-login-submit-btn">
            {loading ? <Loader2 size={16} className="animate-spin" /> : <Lock size={16} />} Giriş Yap
          </button>
          <Link to="/" className="mt-6 block text-center text-xs text-[#CBBBAE] hover:text-[#D4AF37]" data-testid="admin-login-back-link">← Siteye dön</Link>
        </form>
      </div>
    </div>
  );
}
